export const EVENTS_TOPIC = 'events';

export enum MqttTopicVersion {
  V1 = 'v1',
  V2 = 'v2',
  V3 = 'v3',
}

export enum MqttScope {
  PICKING_PICKER_PROFILES = 'picking/picker-profiles',
  RECEIVING_AREAS = 'ekanban/receiving-areas',
}

export enum MqttEvent {
  ORDER_UPDATE = 'order-update',
  UPDATE = 'update',
}
